export const company =
{
    name: 'RE/MAX Executive Homes',
    welcomeName: 'BuyInBangkok.com',
    heroTitle: 'Your Koh Samui Property Solution',
    mainServiceArea: 'Koh Samui',
    phone1: '+66 2-391-8645',
    phone2: '+66 81-823-0785',
    email: 'sales@executive-homes.biz',
    address1: 'Unit 3A, KC Court, Thong Lo 13',
    address2: 'Bangkok, Thailand 10110',
    phoneUrl: 'tel:0800410420',
    lineUrl: 'https://page.line.me/lkw3948e',
    whatsappUrl: 'https://wa.me/66818907469',
    youtubeUrl: '',
    facebookUrl: 'https://www.facebook.com/REMAXExecutiveHomes/',
    instagramUrl: '',
    tiktokUrl: ''
}
